import { QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class CoursesRest {
  baseURL = "/graphs";

  getCourses(params: QueryParams): Observable<any> {
    const url: string = `/courses`;
    return api.get(url, params);
  }

  getCourseTraditional(courseId: string): Observable<any> {
    const url: string = `/third-party/courses/${courseId}`;
    return api.get(url, {}, this.baseURL);
  }

  getCoursesAdmin(params: QueryParams): Observable<any> {
    const url: string = `/admin/courses`;
    return api.get(url, params);
  }

  getCoursesAdminAvailable(): Observable<any> {
    const url: string = `/admin/courses/available`;
    return api.get(url, {}, this.baseURL);
  }

  getCoursesById(courseId: string, baseUrl: string): Observable<any> {
    const url: string = `/courses/${courseId}`;
    return api.get(url, {}, baseUrl);
  }

  getCoursesByIdAdmin(courseId: string): Observable<any> {
    const url: string = `/admin/courses/${courseId}`;
    return api.get(url, {}, this.baseURL);
  }

  getCoursesByListId(data: any): Observable<any> {
    const url: string = `/courses/find-by-list`;
    return api.post(url, data, {}, this.baseURL);
  }

  getCoursesByClassroomId(classroomId: string): Observable<any> {
    const url: string = `/courses/classroom/${classroomId}`;
    return api.get(url, {});
  }
  
  postCourse(data: any): Observable<any> {
    const url: string = `/courses`;
    return api.post(url, data, {});
  }

  updateCourse(courseId: string, data: any): Observable<any> {
    const url: string = `/courses/${courseId}`;
    return api.put(url, data, {});
  }

  sendToApprove(courseId: string, baseUrl: string): Observable<any> {
    const url: string = `/courses/${courseId}/submit`;
    return api.post(url, {}, {}, baseUrl);
  }

  publishCourse(courseId: string, data: any): Observable<any> {
    const url: string = `/courses/${courseId}/approve`;
    return api.post(url, data, {}, this.baseURL);
  }

  approveCourse(courseId: string, data: any, baseUrl: string): Observable<any> {
    const url: string = `/courses/${courseId}/approve`;
    return api.post(url, data, {}, baseUrl);
  }
}
